import React from "react"

function IconPencil({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="pencil"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-pencil"
      {...props}
    >
      <path
        d="M17.164 3.081a1.588 1.588 0 0 1 2.125-.103l.122.11 2.231 2.298c.579.578.615 1.499.109 2.12l-.109.12-2.119 2.119-.006-.005-11.73 11.642H3.273v-4.518L15.006 5.241l2.158-2.16zm-1.241 3.096L4.582 17.41v2.662h2.666L18.552 8.854l-2.63-2.677zm2.555-2.17a.278.278 0 0 0-.33-.045l-.058.044-1.242 1.242 2.636 2.684 1.232-1.231a.274.274 0 0 0 .07-.267l-.03-.068-.046-.061-2.232-2.298z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconPencil
